module.exports = __webpack_public_path__ + "img/honmura.0390f881.jpg";